var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C7.6241 11 7.31936 10.6953 7.31936 10.3194V5.68064C7.31936 5.30473 7.6241 5 8 5V5C8.3759 5 8.68064 5.30473 8.68064 5.68064V10.3194C8.68064 10.6953 8.3759 11 8 11V11ZM5.68064 8.68064C5.30473 8.68064 5 8.3759 5 8V8C5 7.6241 5.30473 7.31936 5.68064 7.31936H10.3194C10.6953 7.31936 11 7.6241 11 8V8C11 8.3759 10.6953 8.68064 10.3194 8.68064H5.68064Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "currentColor"
  })));
};
export default SvgPlus;